export default __webpack_public_path__ + "static/media/DENTAL_PLANS.dde8a0a3.png";